export default __webpack_public_path__ + "static/media/update-icon.fe4c5c21.svg";